export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api";
export const APP_BASE_URL = process.env.REACT_APP_URL;
export const NODE_ENVIRONMENT = process.env.NODE_ENV;
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;
export const { PUBLIC_URL } = process.env;
